<template>
    <div>
        <div class="d-flex justify-content-between">
            <h6 class="font-weight-semi-bold">
                <template v-if="game.name == 'Dice'">{{ 'variants_statistics' | lang }}</template>
                <template v-else>{{ 'symbols_statistics' | lang }}</template>
            </h6>
            <b-button v-b-toggle="'stats'" variant="link">
                <fa-icon icon="caret-up" v-if="isVisible"></fa-icon>
                <fa-icon icon="caret-down" v-else></fa-icon>
            </b-button>
        </div>
        <b-collapse id="stats" v-model="isVisible">
            <b-form-radio-group
                class ="pb-2"
                v-model="activePage"
                button-variant="link"
                :options="options"
                buttons
                name="radios-btn-default">
            </b-form-radio-group>
            <stats-probable-container v-if="activePage == 'probable'" @useSymbols="useStatSymbols" :game-id="gameId"></stats-probable-container>
            <stats-container  v-if="activePage == 'statistic'" @useSymbols="useStatSymbols" :game-id="gameId"></stats-container>
            <stats-lucky-guessed-container v-if="activePage == 'lucky_guessed'" @useSymbols="useStatSymbols" :game-id="gameId"></stats-lucky-guessed-container>
        </b-collapse>
    </div>
</template>

<script>
import Axios from "axios";
import moment from 'moment';

import StatsContainer from "@tv/components/partials/stats/last_draws/Container";
import StatsProbableContainer from "@tv/components/partials/stats/probable/Container";
import StatsLuckyGuessedContainer from "@tv/components/partials/stats/lucky_guessed/Container";
import { syncFrameHeight } from "@tv/helpers";
import lang from '@tv/filters/lang';

export default {
    props: ['gameId'],

    components: { StatsContainer, StatsProbableContainer, StatsLuckyGuessedContainer },

    data() {
        return {
            isVisible: true,
            activePage: 'statistic',
            options: [
                { text: lang('stats.last_draws'), value: 'statistic' },
                { text: lang('stats.probable'), value: 'probable' },
                { text: lang('stats.lucky_guessed'), value: 'lucky_guessed' },
            ],
        };
    },

    methods: {
        useStatSymbols(ids) {
            this.$emit('useSymbols', ids);
        }
    },

    computed: {
        game() {
            return Config.games[this.gameId];
        },
    },

    watch: {
        isVisible() {
            syncFrameHeight();
        },
    },
}
</script>
